import { useState } from "react";
import { authFetch } from "../../lib/auth-fetch";

interface ManualLineupsProps {
	broadcastId: string;
	homeTeam: string;
	awayTeam: string;
}

const parseNames = (text: string): string[] =>
	text
		.split("\n")
		.map((l) => l?.trim())
		.filter(Boolean);

const ManualLineups = ({ broadcastId, homeTeam, awayTeam }: ManualLineupsProps) => {
	const [open, setOpen] = useState(false);
	const [homeXI, setHomeXI] = useState("");
	const [homeSubs, setHomeSubs] = useState("");
	const [awayXI, setAwayXI] = useState("");
	const [awaySubs, setAwaySubs] = useState("");
	const [saving, setSaving] = useState(false);
	const [msg, setMsg] = useState<string | null>(null);

	const handleSave = async () => {
		setSaving(true);
		setMsg(null);
		try {
			const res = await authFetch(`/api/broadcasts/${broadcastId}/lineups`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					homeTeam,
					awayTeam,
					homeXI: parseNames(homeXI),
					homeSubs: parseNames(homeSubs),
					awayXI: parseNames(awayXI),
					awaySubs: parseNames(awaySubs),
				}),
			});
			if (!res.ok) throw new Error("Server error");
			setMsg("Lineups saved!");
			setOpen(false);
		} catch {
			setMsg("Failed to save — check names and try again.");
		}
		setSaving(false);
	};

	if (!open) {
		return (
			<button type="button" onClick={() => setOpen(true)}>
				Enter lineups manually
			</button>
		);
	}

	return (
		<div style={{ border: "1px solid #ccc", padding: "1rem", marginTop: "0.5rem" }}>
			<strong>Enter lineups manually</strong>
			<p style={{ margin: "0.25rem 0 0.75rem", color: "#555", fontSize: "0.9em" }}>
				One player name per line. Starting XI first, then substitutes.
			</p>
			<div style={{ display: "flex", gap: "2rem" }}>
				<div style={{ flex: 1 }}>
					<label><strong>{homeTeam} — Starting XI</strong></label>
					<textarea
						rows={11}
						style={{ display: "block", width: "100%", marginTop: 4 }}
						placeholder={"Goalkeeper\nDefender\n..."}
						value={homeXI}
						onChange={(e) => setHomeXI(e.target.value)}
					/>
					<label style={{ marginTop: 8, display: "block" }}><strong>{homeTeam} — Substitutes</strong></label>
					<textarea
						rows={7}
						style={{ display: "block", width: "100%", marginTop: 4 }}
						placeholder="Sub 1&#10;Sub 2&#10;..."
						value={homeSubs}
						onChange={(e) => setHomeSubs(e.target.value)}
					/>
				</div>
				<div style={{ flex: 1 }}>
					<label><strong>{awayTeam} — Starting XI</strong></label>
					<textarea
						rows={11}
						style={{ display: "block", width: "100%", marginTop: 4 }}
						placeholder={"Goalkeeper\nDefender\n..."}
						value={awayXI}
						onChange={(e) => setAwayXI(e.target.value)}
					/>
					<label style={{ marginTop: 8, display: "block" }}><strong>{awayTeam} — Substitutes</strong></label>
					<textarea
						rows={7}
						style={{ display: "block", width: "100%", marginTop: 4 }}
						placeholder="Sub 1&#10;Sub 2&#10;..."
						value={awaySubs}
						onChange={(e) => setAwaySubs(e.target.value)}
					/>
				</div>
			</div>
			<div style={{ marginTop: "0.75rem", display: "flex", gap: "0.5rem", alignItems: "center" }}>
				<button type="button" onClick={handleSave} disabled={saving}>
					{saving ? "Saving…" : "Save lineups"}
				</button>
				<button type="button" onClick={() => setOpen(false)}>Cancel</button>
				{msg && <span>{msg}</span>}
			</div>
		</div>
	);
};

export default ManualLineups;
